const state = {
  locations: {
    서울: [60, 127],
    부산: [98, 76],
    대구: [89, 90],
    인천: [55, 124],
    광주: [58, 74],
    대전: [67, 100],
    울산: [102, 84],
    세종: [66, 103],
    경기: [60, 120],
    강원: [73, 134],
    충북: [69, 107],
    충남: [68, 100],
    전북: [63, 89],
    전남: [51, 67],
    경북: [89, 91],
    경남: [91, 77],
    제주: [52, 38],
  },
  temp: '10000',
  sky: '',
  pop: '',
  today: {
    year: '',
    month: '',
    date: '',
  },
};

export default state;
